(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    function initializeEmailSignupFeedback(root = document) {
    root.querySelectorAll('.email-signup__form').forEach((form) => {
      if (form.dataset.networkFeedbackInitialized === 'true') return;

      form.dataset.networkFeedbackInitialized = 'true';
      const networkError = form.querySelector('[data-email-signup-network-error]');
      const errorMessage = networkError?.querySelector('[data-email-signup-error-message]');
      const submitButton = form.querySelector('button[type="submit"], button:not([type])');

      const showError = (message) => {
        if (!networkError) return;
        if (errorMessage) errorMessage.textContent = message;
        networkError.hidden = false;
        requestAnimationFrame(() => networkError.focus());
      };

      const submitWithFeedback = async () => {
        if (form.dataset.submitting === 'true') return;
        form.dataset.submitting = 'true';
        form.setAttribute('aria-busy', 'true');
        if (submitButton) submitButton.disabled = true;
        if (networkError) networkError.hidden = true;

        try {
          const response = await fetch(form.action, {
            method: form.method || 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
            redirect: 'follow',
            headers: { Accept: 'text/html' },
          });

          if (!response.ok) {
            showError(networkError?.dataset.serverMessage || 'We could not save your signup. Please try again.');
            return;
          }

          window.location.assign(response.url || `${window.location.pathname}?customer_posted=true#contact_form`);
        } catch (error) {
          showError(
            navigator.onLine
              ? networkError?.dataset.serverMessage || 'We could not save your signup. Please try again.'
              : networkError?.dataset.offlineMessage || 'Check your connection and try again.'
          );
        } finally {
          delete form.dataset.submitting;
          form.removeAttribute('aria-busy');
          if (submitButton) submitButton.disabled = false;
        }
      };

      form.submit = () => {
        if (!navigator.onLine) {
          showError(networkError?.dataset.offlineMessage || 'Check your connection and try again.');
          return;
        }
        void submitWithFeedback();
      };

      form.addEventListener('submit', (event) => {
        if (event.defaultPrevented) return;

        event.preventDefault();
        if (!navigator.onLine) {
          showError(networkError?.dataset.offlineMessage || 'Check your connection and try again.');
          return;
        }

        void submitWithFeedback();
      });
    });

    const successMessage = root.querySelector('.email-signup__message--success');
    if (successMessage) requestAnimationFrame(() => successMessage.focus());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeEmailSignupFeedback());
  } else {
    initializeEmailSignupFeedback();
  }

  document.addEventListener('shopify:section:load', (event) => initializeEmailSignupFeedback(event.target));
  } catch(e) { console.error(e); }
})();

})();
